function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z",
  fill: "#201D1A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10 10.823c0-.234.184-.423.412-.423h.877V7.732c0-.405.318-.732.711-.732.393 0 .712.327.712.732V10.4h.876c.227 0 .412.189.412.423v1.714a.418.418 0 01-.412.423h-.876v4.309A.722.722 0 0112 18a.72.72 0 01-.711-.731V12.96h-.877a.418.418 0 01-.412-.423v-1.54a.417.417 0 01-.411.422h-.877v5.85A.722.722 0 018 18a.722.722 0 01-.712-.731v-5.85H6.41a.417.417 0 01-.411-.422V9.282c0-.234.184-.423.411-.423h.877V7.732A.723.723 0 018 7c.393 0 .712.327.712.732v1.127h.877c.227 0 .411.19.411.423v1.54zM16 7c.393 0 .712.327.712.732v6.262h.877c.227 0 .411.19.411.423v1.715a.417.417 0 01-.411.423h-.877v.714A.722.722 0 0116 18a.722.722 0 01-.712-.731v-.714h-.877a.418.418 0 01-.411-.423v-1.715c0-.233.184-.422.411-.422h.877V7.732c0-.405.319-.732.712-.732z"
});

var SvgMixes = function SvgMixes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMixes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mixes.1c8a11cd.svg";
export { ForwardRef as ReactComponent };